import { ReviewAuditIntent } from 'screens/performanceReview/LandingPage/ReviewAuditIntent';

const ReviewsIntentLandingPage = ({ gridRef }) => <ReviewAuditIntent gridRef={gridRef} />;

export { ReviewsIntentLandingPage };
